import { ReactNode } from "react";
import signalLogo from "@/assets/signal-logo.svg";

interface PublicShareLayoutProps {
  sharedBy: string;
  children: ReactNode;
}

export function PublicShareLayout({ sharedBy, children }: PublicShareLayoutProps) {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-border bg-white px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img src={signalLogo} alt="Signal" className="h-10 w-auto brightness-0" />
        </div>
        <span className="text-sm text-muted-foreground">
          Shared by{" "}
          <span className="text-foreground font-medium truncate max-w-[40ch]">{sharedBy}</span>
        </span>
      </header>
      <main className="px-6 py-8">{children}</main>
    </div>
  );
}
